import {CanDeactivateFn} from '@angular/router';
import {CanDeactivateComponent} from '../api/candeactivate/can-deactivate';
import {DeactivateUtil} from "@shared/util/general/deactivate-utils";
import {Observable, of} from 'rxjs';
import {inject} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

export const CanDeactivateGuard: CanDeactivateFn<CanDeactivateComponent> = (component: CanDeactivateComponent): Observable<boolean> => {
  if (component.displayDeactivateConfirmation()) {
    return DeactivateUtil.confirmDeactivate(
      inject(NgbModal),
      component.getDeactivateModalOptions());
  } else {
    return of(true);
  }
};
